import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { Button } from 'UIPackage/MainModule/components/Button';
import { ConfirmModal } from 'UIPackage/MainModule/components/ConfirmModal';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';

import styles from './AdminEditForm.module.scss';
import { adminUpdateFrgu } from '../actions/adminAction';

interface IOrganizationsAndFunctionsEditFormProps {
  onBack: () => void;
}

export const OrganizationsAndFunctionsEditForm = ({ onBack }: IOrganizationsAndFunctionsEditFormProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const [isConfirmVisible, setIsConfirmVisible] = useState(false);

  const onOpen = useCallback(() => setIsConfirmVisible(true), []);
  const onApply = useCallback(() => dispatch(adminUpdateFrgu()), [dispatch]);
  const onClose = useCallback(() => setIsConfirmVisible(false), []);

  return (
    <div>
      <div className={styles.ControlButtons}>
        <Button
          className={styles.Button}
          color="primary"
          type="button"
          variant="contained"
          onClick={onOpen}
          text="Обновить справочники ФРГУ"
        />
        <Button
          className={styles.Button}
          color="default"
          type="button"
          variant="contained"
          onClick={onBack}
          text="Назад"
        />
      </div>
      <ConfirmModal
        visible={isConfirmVisible}
        title="Предупреждение"
        text="Обновить справочники ФРГУ. Вы уверены?"
        cancelButtonText="Нет"
        onApply={onApply}
        onClose={onClose}
      />
    </div>
  );
};
